module.exports = __webpack_public_path__ + "static/media/231BL.60659e2d.jpg";